export enum VideoType {
    brightcove = 'brightcove',
    vimeo = 'vimeo',
    youtube = 'youtube'
}
